import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import CssCodeEditor from "../../../components/CssCodeEditor";
import JsCodeEditor from "../../../components/JsCodeEditor";
import ColorPicker from "../../../components/ColorPicker";

const StyleTab = ({ updateCookieConsentTabData,cookieConsentTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [backgroundColor, setBackgroundColor] = useState(cookieConsentTabData.background_color);
    const [textColor, setTextColor] = useState(cookieConsentTabData.text_color);
    const [linkColor, setLinkColor] = useState(cookieConsentTabData.link_color);
    const [allowButtonColor, setAllowButtonColor] = useState(cookieConsentTabData.allow_button_color);
    const [declineButtonColor, setDeclineButtonColor] = useState(cookieConsentTabData.decline_button_color);
    const [confirmationButtonBackgroundColor, setConfirmationButtonBackgroundColor] = useState(cookieConsentTabData.confirmation_button_background_color);
    const [textFontSize, setTextFontSize] = useState(cookieConsentTabData.text_font_size);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(cookieConsentTabData.style_custom_css);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(cookieConsentTabData.style_custom_js);

    // Handlers Background Color Change
    const handleBackgroundColorChange = (color) => {
        setBackgroundColor(color.hex);
        updateCookieConsentTabData("background_color", color.hex);
    };

    // Handlers Text Color Change
    const handleTextColorChange = (color) => {
        setTextColor(color.hex);
        updateCookieConsentTabData("text_color", color.hex);
    };

    // Handlers Link Color Change
    const handleLinkColorChange = (color) => {
        setLinkColor(color.hex);
        updateCookieConsentTabData("link_color", color.hex);
    };

    // Handlers Allow Button Color Change
    const handleAllowButtonColorChange = (color) => {
        setAllowButtonColor(color.hex);
        updateCookieConsentTabData("allow_button_color", color.hex);
    };

    // Handlers Decline Button Color Change
    const handleDeclineButtonColorChange = (color) => {
        setDeclineButtonColor(color.hex);
        updateCookieConsentTabData("decline_button_color", color.hex);
    };

    // Handlers Confirmation Button Background Color Change
    const handleConfirmationButtonBackgroundColor = (color) => {
        setConfirmationButtonBackgroundColor(color.hex);
        updateCookieConsentTabData("confirmation_button_background_color", color.hex);
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updateCookieConsentTabData("style_custom_css", code);
    };

    // Handlers Text Font Size Change
    const handleTextFontSizeChange = (e) => {
        const value = `${e.target.value}px`;
        setTextFontSize(value);
        updateCookieConsentTabData("text_font_size", value);
    }; 

    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateCookieConsentTabData("style_custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Style</span>
                    <div className="name-tile-row">Colors</div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Background Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={backgroundColor} setColor={setBackgroundColor}  onChangeComplete={handleBackgroundColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Text Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={textColor} setColor={setTextColor}  onChangeComplete={handleTextColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Link Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={linkColor} setColor={setLinkColor}  onChangeComplete={handleLinkColorChange}/>
                            </div>
                        </div>
                        {cookieConsentTabData.compliance_type === 'Show_Allow_Cookies' && (
                        <>
                            <div className="box-header-row">
                                <span>Allow Button Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={allowButtonColor} setColor={setAllowButtonColor}  onChangeComplete={handleAllowButtonColorChange}/>
                                </div>
                            </div>
                            <div className="box-header-row">
                                <span>Decline Button Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={declineButtonColor} setColor={setDeclineButtonColor}  onChangeComplete={handleDeclineButtonColorChange}/>
                                </div>
                            </div>
                        </>
                        )}
                        {cookieConsentTabData.compliance_type === 'Hide_Allow_Cookies' && (
                        <>
                            <div className="box-header-row">
                                <span>Confirmation Button Color</span>
                                <div className="color-pikr-box">
                                    <ColorPicker color={confirmationButtonBackgroundColor} setColor={setConfirmationButtonBackgroundColor}  onChangeComplete={handleConfirmationButtonBackgroundColor}/>
                                </div>
                            </div>
                        </>
                        )}
                    </div>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Text Font Size</span>
                            <em>{textFontSize}</em>
                            <div className="slider-container">
                                <input type="range" min="10px" max="20px" value={parseInt(textFontSize)} onChange={handleTextFontSizeChange}/>
                            </div>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default StyleTab;